export default __webpack_public_path__ + "static/media/blue_background.25fb8171.jpeg";